import React, { useRef, useState } from "react";
import { Button, Typography } from "@mui/material";
import { translate } from "../../../../i18n/customI18nProvider";

export default function FileInput(props) {
    const {handleChange, sx} = props;
    const inputRef = useRef(null);
    const [fileName, setFileName] = useState("");

    const handleClick = () => {
        inputRef.current.click();
    };

    const handleChangeEvent = (event) => {
        const file = event.target.files[0];
        if(handleChange) handleChange(event);
        if (file) setFileName(file.name);
        event.target.value = null;
    };

    return (
        <>
        <input
            type="file"
            ref={inputRef}
            onChange={handleChangeEvent}
            style={{ display: "none" }}
        />

        <Button variant="contained" onClick={handleClick} sx={sx}>
            {translate('custom.select_file')}
        </Button>
        </>
    );
}